import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import ProjectForm from '@app/components/project/ProjectForm';

const ProjectAddPage = () => {
  return (
    <>
      <PageTitle>Thêm dự án</PageTitle>
      <BaseRow gutter={[30, 30]}>
        <BaseCol xs={24} md={24} xl={24}>
          <ProjectForm />
        </BaseCol>
      </BaseRow>
    </>
  );
};

export default ProjectAddPage;
